import { Component, OnInit, Input } from '@angular/core';
import { PhotographerNetwork } from "projects/photographer-network/src/app/photographer-network.service";

@Component({
  selector: 'app-photographer-card',
  templateUrl: './photographer-card.component.html',
  styleUrls: ['./photographer-card.component.scss']
})
export class PhotographerCardComponent implements OnInit {
  @Input() ph: PhotographerNetwork;
  constructor() { }

  ngOnInit() {
  }

}
